import React from "react";
import { dateFormat } from "../../helper/dateConvertor";
import "./InfoCard.scss";

const InfoCard = ({ info }) => {
  const date = dateFormat(info.createddate)
  return (
    <div className="Info__card">
      <div className="Info__card--container">
        <div className="card__sub-container name">
          <h2 className="title-gray-black-18">{info.name}</h2>
        </div>
        <div className="card__sub-container locations">
          <h2 className="paragraph-gray-reg-14">Locations</h2>
          <div className="locations--content">
            {info.location.map((loc, i) => (
              <p key={`${info.name}${i}`} className="paragraph-gray-bold-14 location-item">{loc.label}</p>
            ))}
          </div>
        </div>
        <div className="card__sub-container areas">
          <h2 className="paragraph-gray-reg-14">Areas</h2>
          <div className="areas--content">
            {info.specialty.map((sp, i) => (
              <p  key={`${info.name}${i}`}  className="paragraph-gray-bold-14">{sp.name}</p>
            ))}
          </div>
        </div>
        <div className="card__sub-container create-by">
          <h2 className="paragraph-gray-reg-14">Created by</h2>
          <p className="paragraph-gray-bold-14">{info.creatorName}</p>
        </div>
        <div className="card__sub-container create-at">
          <h2 className="paragraph-gray-reg-14">Created at</h2>
          <p className="paragraph-gray-bold-14">{date}</p>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
